<template>
  <div class="main">
    <div class="container">
      <div class="button-container">
        <BaseButtonOctagon text="Stare<br>down" @click.native="onOpponentSelected()" v-if="unlocked"/>
        <BaseLockedSymbolOctagon v-else/>
      </div>
      <div class="gradient"/>
      <Title
        ref="title"
        :opponent="opponent"
        :unlocked="unlocked"
        @button-clicked="$emit('open-stats')"
      />
      <div class="opponent-image-container" ref="opponent-image-container">
        <div class="opponent-image-wrapper" ref="opponent-image-wrapper">
          <img v-if="unlocked" class="opponent-image" :src="opponent.image1" data-depth="0.5">
          <img v-else class="opponent-image" :src="opponent.image4" data-depth="0.5">
        </div>
      </div>
      <img ref="number" class="number" :src="numberImage">
    </div>
  </div>
</template>

<script>
import BaseButtonOctagon from '@/components/BaseButtonOctagon/BaseButtonOctagon'
import BaseLockedSymbolOctagon from '@/components/BaseLockedSymbolOctagon/BaseLockedSymbolOctagon'
import Title from '../../components/Title/Title'
import Parallax from 'parallax-js'
import { TimelineMax, Power1 } from 'gsap'
import { mapState } from 'vuex'
export default {
  components: {
    BaseButtonOctagon,
    BaseLockedSymbolOctagon,
    Title
  },
  mounted () {
    this.tl = this.createTl()
    this.parallax = new Parallax(this.$refs['opponent-image-wrapper'], { limitY: 0 })
  },
  props: {
    opponent: {
      type: Object,
      required: true
    },
    numberImage: {
      type: String,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      tl: null
    }
  },
  computed: mapState('ui', [
    'faceCalibrationComplete'
  ]),
  methods: {
    createTl () {
      const tl = new TimelineMax({ paused: true })
      tl.from(this.$refs['number'], 1, { autoAlpha: 0, x: -10, ease: Power1.easeOut }, 0.25)
      tl.add(this.$refs['title'].tl, 0.5)
      return tl
    },
    onOpponentSelected () {
      this.$ga.event('opponent-selected', this.opponent.id)
      this.$store.commit('gameplay/setSelectedOpponentId', this.opponent.id)
      const nextRoute = this.faceCalibrationComplete ? '/gameplay' : '/calibration'
      if (localStorage.getItem('userHasSeenInstructions')) return this.$router.push(nextRoute)
      this.$router.push({ name: 'instructions', params: { nextRoute } })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacing-1) + 1rem);
  display: flex;
}
.container {
  width: 100%;
  height: 100%;
  padding: var(--spacing-1) var(--spacing-1) calc(var(--spacing-1) * 2);
  display: flex;
  flex-direction: column;
  position: relative;
}
.button-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.opponent-image-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: visible;
  pointer-events: none;
  z-index: -2;
}
.opponent-image-wrapper {
  position: absolute;
  height: 108%;
  bottom: 0;
  left: -35%;
  display: block;
}
.opponent-image {
  height: 100%;
  display: block;
}
.number {
  position: absolute;
  top: var(--spacing-1);
  right: var(--spacing-1);
  height: 10rem;
  pointer-events: none;
}
.gradient {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 12rem;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  pointer-events: none;
  will-change: transform;
}
</style>
